export const GROUP_PERMISSIONS = {
    show_content: 'show-content',
    companies: 'companies',
    packages: 'packages',
    telegrams: 'telegrams',
    transactions: 'transactions',
    users: 'users',
    roles: 'roles',
    sim_passports: 'sim-passports',
    mbh_topups: 'mbh-topups',
    mbh_tkg_dashboard: 'mbh-tkg-dashboard',
    data_sponsor: 'data-sponsor',
    user_partner: 'user-partner',
    mbh_tkg_dashboard_partner: 'mbh-tkg-dashboard-partner',
    transaction_connection: 'transaction-connection',
    registration_request: 'registration-request',
    order_transaction_connection: 'order-transaction-connection',
    statistical_service: 'statistical-service',
    customer_resource: 'customer-resource',
    phone_agency: 'phone-agency',
    call_info: 'call-info',
    inventory_service: 'inventory-service',
    config: 'config',
    invoice: 'invoice',
    report: 'report',
}